import { message } from "antd";
import axios from "axios";
import { getToken } from "./auth";
import { getDeviceInfo } from "utils/device";
import { settings } from "settings";

message.config({
  duration: 1.5,
});

// create an axios instance
const service = axios.create({
  baseURL: import.meta.env.VITE_API_URL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    const token = getToken();
    if (token && config.headers) {
      config.headers["token"] = token;
    }

    if (config.headers) {
      config.headers["version"] = settings.version;
      const { deviceId, deviceName } = getDeviceInfo();
      config.headers["device-name"] = deviceName;
      config.headers["device-id"] = deviceId;
    }

    return config;
  },
  (error) => {
    console.log(error); // for debug
    return Promise.reject(error);
  },
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (response.status !== 200) {
      if (response.status === 50008 || response.status === 50012 || response.status === 50014) {
      }
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    let status = error.response ? error.response.status : false;
    let msg = "";
    if (status) {
      msg = error.response.data.message;
    } else {
      msg = error.message;
    }
    message.error(msg);

    return Promise.reject(error);
  },
);

export { service as request };
